import { ListLink, ListLinkProps } from "@/components";

export type Props = ListLinkProps;

export const ListExpired: React.FC<Props> = (props) => {
  return <ListLink {...props} />;
};
